import { Box, Flex } from '@chakra-ui/react';
import Header, { headerHeight } from 'presentation/layout/shared/Header/Header';
import { FC, PropsWithChildren } from 'react';
import NavBar, { navbarHeight } from 'presentation/layout/shared/NavBar';
import Footer from 'presentation/layout/shared/Footer/Footer';
import useScrollToTop from 'hooks/shared/useScrollToTop';

interface Props {
  scrollResetKey?: string;
  stableScrollArea?: boolean;
  responsive?: boolean;
}

const PageLayout: FC<PropsWithChildren<Props>> = ({ children, scrollResetKey, stableScrollArea = false, responsive = false }) => {
  const scrollableBody = useScrollToTop(scrollResetKey);

  return (
    <Flex flexDirection="column" height="100vh">
      <Header />
      {responsive ? <Box overflowX="auto" flexShrink={0}><NavBar /></Box> : <NavBar />}
      <Flex
        ref={scrollableBody}
        minW={responsive ? 0 : '980px'}
        flexDir="column"
        minH={`calc(100vh - ${headerHeight + navbarHeight}px)`}
        flex="1"
        overflow="auto"
        sx={stableScrollArea ? {
          '--page-scroll-height': `calc(100vh - ${headerHeight + navbarHeight}px)`,
          scrollbarGutter: 'stable',
          scrollBehavior: 'auto',
          overflowAnchor: 'none',
          '@supports not (scrollbar-gutter: stable)': { overflowY: 'scroll' },
          '& > *': { flexShrink: 0 },
        } : undefined}
        pt={stableScrollArea ? 0 : '20px'}
        justifyContent="space-between"
      >
        <Box pt={stableScrollArea ? '20px' : undefined} mb="20px">{children}</Box>
        {responsive ? <Box overflowX="auto"><Footer /></Box> : <Footer />}
      </Flex>
    </Flex>
  );
};

export default PageLayout;
